// extracted by mini-css-extract-plugin
module.exports = {"centered":"centered_35lYYzvB"};